export default "__VITE_PUBLIC_ASSET__fc84a8f3__"